import { createFileRoute } from "@tanstack/react-router";
import { AdminShell } from "@/components/AdminShell";
import { AdminScanLab } from "@/components/AdminScanLab";

export const Route = createFileRoute("/_authenticated/admin/skannlabb")({
  head: () => ({
    meta: [
      { title: "Skannlabb — Administration" },
      {
        name: "description",
        content:
          "Internt: kör film- och bildskanning med full spårning av varje AI- och API-anrop, och spara resultaten.",
      },
      { name: "robots", content: "noindex" },
      { property: "og:title", content: "Skannlabb — Administration" },
      {
        property: "og:description",
        content: "Testa skanningen steg för steg och granska sparade körningar.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: () => (
    <AdminShell title="Skannlabb">
      <AdminScanLab />
    </AdminShell>
  ),
});
